import { Table, Badge, NumberFormatter } from "@mantine/core";
import type { CptByPracticeRow } from "../../services/reports.service";

export interface PracticeCodeTableProps {
  byPracticeRows: CptByPracticeRow[];
}

export function PracticeCodeTable({ byPracticeRows }: PracticeCodeTableProps) {
  return (
    <Table striped highlightOnHover withTableBorder>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Practice</Table.Th>
          <Table.Th>Code</Table.Th>
          <Table.Th>Stain Classification</Table.Th>
          <Table.Th>Count</Table.Th>
          <Table.Th>Unit Fee</Table.Th>
          <Table.Th>Total Fee</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {byPracticeRows.flatMap((practice) =>
          practice.breakdown.map((row) => (
            <Table.Tr
              key={`${practice.practiceId}-${row.cptCodeId}-${row.cptCode}`}
            >
              <Table.Td>{practice.practiceName}</Table.Td>
              <Table.Td>
                <Badge variant="outline" size="sm">
                  {row.cptCode}
                </Badge>
              </Table.Td>
              <Table.Td>{row.stainClassification || "—"}</Table.Td>
              <Table.Td>{row.count}</Table.Td>
              <Table.Td>
                {row.unitFee != null ? (
                  <NumberFormatter
                    value={row.unitFee}
                    prefix="$"
                    decimalScale={2}
                  />
                ) : (
                  "—"
                )}
              </Table.Td>
              <Table.Td>
                {row.totalFee != null ? (
                  <NumberFormatter
                    value={row.totalFee}
                    prefix="$"
                    decimalScale={2}
                  />
                ) : (
                  "—"
                )}
              </Table.Td>
            </Table.Tr>
          ))
        )}
      </Table.Tbody>
    </Table>
  );
}
